"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
exports.default = function (allCourses, courseMap) {
    var validations = {
        // too non-deterministic
        multiLOTE: {
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, {}, "multi-lote", 4),
            options: courseOptionsFromCourseMap_1.default(courseMap, {}, 4, "multi-lote-options")
        },
        lote: {
            // no schools pass not enough classes in TEA data, much less a single school
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, {}, "lote", 4),
            options: courseOptionsFromCourseMap_1.default(courseMap, {}, 4, "lote-options")
        },
        socialStudies: {
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, __assign({}, oneThirteenCourses, oneEighteenCourses), "social-studies", 5),
            options: courseOptionsFromCourseMap_1.default(courseMap, __assign({}, oneThirteenCourses, oneEighteenCourses), 5, "social-studies-options")
        },
        americanSignLanguage: {
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, aslCourseMap, "american-sign-language", 4),
            options: courseOptionsFromCourseMap_1.default(courseMap, aslCourseMap, 4, "american-sign-language-options")
        },
        englishElectivesNotIncludedInBusinessAndIndustry: {
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, englishCourseMap, "english-electives-not-included-in-business-and-industry", 4),
            options: courseOptionsFromCourseMap_1.default(courseMap, englishCourseMap, 4, "english-electives-not-included-in-business-and-industry-options")
        }
    };
    return validations;
};
var oneThirteenCourses = {
    "us history studies since 1877": 1,
    "world history studies": 1,
    "world geography studies": 1,
    "united states government": 0.5,
    psychology: 0.5,
    sociology: 0.5,
    "spec topic in soc stud": 0.5,
    "soc stud research meth": 0.5,
    "social studies adv": 1,
    "ap united states history": 1,
    "ap european history": 1,
    "ap world history": 1,
    "ap human geography": 1,
    "ap u.s. government & politics": 0.5,
    "ap comparative govt & politics": 0.5,
    "ap psychology": 0.5,
    "ib history standard level": 2,
    "ib hist of americas higher lvl": 1,
    "ib hist of europe higher level": 1,
    "ib geography standard level": 2,
    "ib geography higher level": 2,
    "ib psychology standard level": 2,
    "ib psychology higher level": 2,
    /* new courses added 2018-06-26 */
    "ib business & mgt i": 1,
    "ib business & mgt ii": 1,
    "ib economics, higher level": 1,
    "ib economics standard level": 2,
    "ib philosophy standard level": 2,
    "mexican american studies": 1,
    "personal financial literacy": 0.5,
    "research methods humanities": 1,
    "social std adv stdys": 1,
    "spc top soc stu:hb scr/old tst": 0.5,
    "spcl soc stud tpcs hebrw/ntest": 1,
    "spec top soc stud: new test": 0.5,
    "spec topics in soc stud": 0.5,
};
var oneEighteenCourses = {
    "economics w/emph free enterpr": 1,
    "ib economics, standard level": 1,
    "ib economics, higher level": 1,
    /* new courses added 2018-06-26 */
    "ap macroeconomics": 0.5,
    "ap microeconomics": 0.5,
    "economics adv studies": 0.5,
};
var aslCourseMap = {
    "lang o/t english i - asl": 1,
    "lang o/t english ii - asl": 1,
    "lang o/t english iii - asl": 1,
    "lang o/t english iv - asl": 1
};
var englishCourseMap = {
    "english iv": 1,
    "indep study/english": 1,
    "literary genres": 1,
    "creative writing": 1,
    humanities: 1,
    "communication applications": 0.5,
    "ap english literature and comp": 1,
    "ap english language and comp": 1,
    /* new courses added 2018-06-26 */
    "adv journalism: lit mag ii": 1,
    "adv journalism: lit mag iii": 1,
    "adv journalism: lit magazine i": 1,
    "colge prep crse engl lang arts": 1,
    "ib english iv": 1,
    "ind std in eng: hbr scr & ntst": 1,
    "indep study in eng:heb scrip": 1,
    "indep study in eng:new test": 1,
    "indep study/journalism": 1,
    "indep study/speech": 1,
    "ib language studies a1 hl": 1
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/artsAndHumanities/index.js
// module id = 440
// module chunks = 22